import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import Hls from 'hls.js';

import throttle from 'lodash/throttle';
import Icon from '../icons/Icon';

class MobileVideoPlayer extends Component {
  static propTypes = {
    progressThrottle: PropTypes.number.isRequired,
    time: PropTypes.number.isRequired,
  };

  componentWillUnmount = () => {
    const { onEnd, onPlay } = this.props;
    this.videoElement.removeEventListener('ended', onEnd);
    this.videoElement.removeEventListener('timeupdate', this.handleProgress);
    this.videoElement.removeEventListener('playing', onPlay);
    if (this.hls) {
      this.hls.destroy();
    }
  };

  handleProgress = throttle(
    e => {
      if (this.props.onProgress) {
        this.props.onProgress(e.target.currentTime);
      }
    },
    this.props.progressThrottle,
    { trailing: true }
  );

  setVideoRef = videoElement => {
    const { onEnd, onPlay, source, time } = this.props;

    if (videoElement && !this.videoElement) {
      this.videoElement = findDOMNode(videoElement);

      this.videoElement.addEventListener('ended', onEnd);
      this.videoElement.addEventListener('timeupdate', this.handleProgress);
      this.videoElement.addEventListener('playing', onPlay);

      if (Hls.isSupported()) {
        this.hls = new Hls();

        this.hls.attachMedia(this.videoElement);

        this.hls.on(Hls.Events.MEDIA_ATTACHED, () => {
          this.hls.loadSource(`${source}hls.m3u8#t=${time}`);
        });

        this.hls.on(Hls.Events.ERROR, (event, data) => {
          if (data.fatal) {
            switch (data.type) {
              case Hls.ErrorTypes.NETWORK_ERROR:
                this.hls.startLoad();
                break;
              case Hls.ErrorTypes.MEDIA_ERROR:
                this.hls.recoverMediaError();
                break;
              default:
                this.hls.destroy();
                break;
            }
          }
        });
      }
    }
  };

  render = () => {
    const { autoplay, source, backText, poster, time } = this.props;

    return (
      <div className="mobile-video-player">
        {backText && (
          <button className="mvp-go-back" onClick={this.props.goBack}>
            <Icon icon="BackArrow" />
            <span className="mvp-go-back--text">Go Back</span>
          </button>
        )}
        <video poster={poster} autoPlay={autoplay} ref={this.setVideoRef} controls>
          {!Hls.isSupported() && <source src={`${source}mobile-720.mp4#t=${time}`} type="video/mp4" />}
          <h3>Your browser does not support HTML 5 video.</h3>
        </video>
      </div>
    );
  };
}

export default MobileVideoPlayer;



// WEBPACK FOOTER //
// ./src/common/video/MobileVideoPlayer.js